import React from 'react'
import { inject, observer } from 'mobx-react'

export const MonthRenderer = inject('monthStore')(observer(
  ({monthStore}) => <span className="month">{monthStore.current}</span>
))

